import React from 'react';

function PaintBrushIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				fill='#EDF876'
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M4 5c0-.744 0-1.116.09-1.42a2.2 2.2 0 011.49-1.49C5.884 2 6.256 2 7 2h7c.744 0 1.116 0 1.42.09a2.2 2.2 0 011.49 1.49c.09.304.09.676.09 1.42 0 .744 0 1.116-.09 1.42a2.2 2.2 0 01-1.49 1.49C15.116 8 14.744 8 14 8H7c-.744 0-1.116 0-1.42-.09a2.2 2.2 0 01-1.49-1.49C4 6.116 4 5.744 4 5z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M12 17.5c0-.466 0-.699.076-.883a1 1 0 01.541-.54c.184-.077.417-.077.883-.077s.699 0 .883.076a1 1 0 01.54.541c.077.184.077.417.077.883v3c0 .466 0 .699-.076.883a1 1 0 01-.541.54c-.184.077-.417.077-.883.077s-.699 0-.883-.076a1 1 0 01-.54-.541C12 21.199 12 20.966 12 20.5v-3z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M17.249 5c.855 0 1.282 0 1.62.152C19.997 5.662 20 6.862 20 8.004c0 .957 0 1.435-.13 1.838-.419 1.296-2.131 1.926-3.786 2.395-1.183.336-1.775.503-2.18 1.039-.404.535-.404 1.163-.404 2.42V16'
			></path>
		</svg>
	);
}

export default PaintBrushIcon;
